export const GENERAL_SECTION_SPACING = [10, 10, "112px"];
